// src/components/common/LoadingSpinner.js
import React from 'react';
import styles from './LoadingSpinner.module.css';

/**
 * Tidy centered spinner.
 * - Default: inline, fills its parent frame (use inside framed loading/empty states).
 * - overlay: fixed full-screen scrim for blocking loads.
 */
const LoadingSpinner = ({ label, overlay = false }) => {
  const spinner = (
    <div className={styles.wrap}>
      <div className={styles.spinner} aria-hidden="true" />
      {label ? <p className={styles.label}>{label}</p> : null}
    </div>
  );

  if (overlay) {
    return (
      <div className={styles.overlay} role="status" aria-live="polite">
        {spinner}
      </div>
    );
  }

  return (
    <div role="status" aria-live="polite">
      {spinner}
    </div>
  );
};

export default LoadingSpinner;
